<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">
                {{ EhEdicao ? "Editar Equipe" : "Nova Equipe" }}
              </strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>* Nome</label>
                    <input
                      v-model="viewModel.name"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome da equipe"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>Descrição</label>
                    <input
                      v-model="viewModel.description"
                      class="form-control"
                      type="text"
                      placeholder="Digite a descrição"
                    />
                  </div>
                </div>
                <div
                  class="col-sm-6 col-md-2 col-lg-2 col-xl-1"
                  title="Informa se a equipe está ativa para receber ordens de serviço."
                >
                  <label for>Ativa</label>
                  <b-form-checkbox
                    v-model="viewModel.active"
                    name="check-button"
                    switch
                  >
                    Sim
                  </b-form-checkbox>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-5">
                  <div class="form-group">
                    <label for>Adicionar membro</label>
                    <v-select
                      v-model="usuarioSelecionado"
                      placeholder="Digite o nome do usuário"
                      :options="usuarios"
                      @search="BuscarUsuarios"
                      @input="AdicionarMembro"
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8">
                  <b-table
                    :hover="true"
                    responsive
                    striped
                    :items="viewModel.members"
                    :fields="fieldsMembros"
                    show-empty
                    empty-text="Nenhum membro adicionado."
                  >
                    <template v-slot:empty="scope">
                      <h6 class="mt-2">{{ scope.emptyText }}</h6>
                    </template>
                    <template v-slot:cell(isLeader)="data">
                      <div class="center">
                        <b-form-checkbox
                          v-model="data.item.isLeader"
                          name="check-button"
                          switch
                        >
                        </b-form-checkbox>
                      </div>
                    </template>
                    <template v-slot:cell(acoes)="data">
                      <b-button
                        variant="danger"
                        size="sm"
                        title="Remover membro"
                        @click="RemoverMembro(data.index)"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="btn-toolbar mb-3 ml-3" role="toolbar">
              <div class="btn-group" role="group">
                <button class="btn btn-success mr-2" type="submit">
                  Salvar
                </button>
              </div>
              <div class="btn-group" role="group">
                <button
                  class="btn btn-secondary"
                  type="reset"
                  @click="$router.go(-1)"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import TeamService from "../../servico/TeamService";
import UsuarioServico from "../../servico/UsuarioServico";
import ApiError from "../../util/ApiError";

export default {
  name: "NewTeam",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      usuarios: [],
      usuarioSelecionado: null,
      viewModel: {
        id: null,
        name: "",
        description: "",
        active: true,
        members: []
      },
      fieldsMembros: [
        { key: "nome", label: "Nome", sortable: true },
        { key: "isLeader", label: "Líder", sortable: false },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  computed: {
    EhEdicao() {
      return !!this.viewModel.id;
    }
  },
  created() {
    this.BuscarUsuarios("");
    let id = this.$route.params.id;
    if (id) this.Obter(id);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.EhEdicao) this.Editar();
      else this.Novo();
    },
    BuscarUsuarios(busca) {
      // O endpoint recebe o termo como segmento de rota, entao nunca pode ir vazio.
      let termo = busca && busca.trim().length > 0 ? busca : " ";

      UsuarioServico.ObterVSelect(termo)
        .then((resposta) => {
          this.usuarios = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    AdicionarMembro(usuario) {
      if (!usuario) return;

      let jaExiste = this.viewModel.members.some(
        (x) => x.usuarioId === usuario.id
      );

      if (jaExiste) {
        this.usuarioSelecionado = null;
        this.$notify({
          data: ["Esse usuário já faz parte da equipe."],
          type: "warn",
          duration: 5000
        });
        return;
      }

      this.viewModel.members.push({
        id: null,
        usuarioId: usuario.id,
        nome: usuario.label,
        email: usuario.email || "",
        isLeader: false
      });

      this.usuarioSelecionado = null;
    },
    RemoverMembro(indice) {
      this.viewModel.members.splice(indice, 1);
    },
    MontarMembros() {
      return this.viewModel.members.map((item) => {
        return {
          id: item.id || null,
          usuarioId: item.usuarioId,
          isLeader: !!item.isLeader
        };
      });
    },
    Obter(id) {
      this.loading = true;

      TeamService.Get(id)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
          if (!this.viewModel.members) this.viewModel.members = [];
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Novo() {
      this.loading = true;

      TeamService.New({
        name: this.viewModel.name,
        description: this.viewModel.description,
        active: this.viewModel.active,
        members: this.MontarMembros()
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/equipe");
          this.$notify({
            data: ["Equipe cadastrada com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Editar() {
      this.loading = true;

      TeamService.Edit({
        id: this.viewModel.id,
        name: this.viewModel.name,
        description: this.viewModel.description,
        active: this.viewModel.active,
        members: this.MontarMembros()
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/equipe");
          this.$notify({
            data: ["Equipe editada com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
